import { ValidationErrors } from 'final-form';
import React from 'react';
import { useIntl } from 'react-intl';

import { ChevronDownMini } from '@xsolla/ui-icons';

import { useAnimatedCollapse } from '../../../hooks';
import {
  CheckListCardContent,
  CheckListCardHead,
  CheckListCardTitle,
  ChevronMiniWrapper,
  CustomStorageCardWrapper,
  FlexWithGap,
  TitlesWrapper
} from '../../SetupSteps/SetupStepsComponents/style';
import { FieldInput, FieldInputNumber } from '../../ui';
import { MappingFields } from './MappingFields';
import { CustomStorageFieldTypes, StorageFieldLinks } from './settings';
import { CustomFieldsWrapper, CustomMapWrapper } from './style';
import { prefixesShowMap } from './utils';

type Props = {
  isOpened?: boolean;
  fieldName: CustomStorageFieldTypes;
  errors: ValidationErrors;
};

const CustomStorageCard = ({ fieldName, errors, isOpened = false }: Props): JSX.Element => {
  const { collapseHandle, contentHeight, ref } = useAnimatedCollapse({ isOpen: isOpened });
  const intl = useIntl();

  return (
    <CustomStorageCardWrapper>
      <CheckListCardHead onClick={collapseHandle}>
        <FlexWithGap>
          <TitlesWrapper>
            <CheckListCardTitle>
              {intl.messages[`user-data-base.settings.user-storage.custom.${fieldName}.label`]}
            </CheckListCardTitle>
          </TitlesWrapper>
        </FlexWithGap>
        <ChevronMiniWrapper isOpen={!!contentHeight}>
          <ChevronDownMini />
        </ChevronMiniWrapper>
      </CheckListCardHead>
      <CheckListCardContent ref={ref} contentHeight={contentHeight}>
        <CustomFieldsWrapper key={`${fieldName}_wrapper`}>
          <FieldInput
            name={`${fieldName}_url`}
            label={intl.messages[`user-data-base.settings.user-storage.custom.${fieldName}.label`]}
            errorMessage={intl.messages[errors?.[fieldName]] as string}
            extraLink={{
              title: intl.messages[`user-data-base.settings.user-storage.custom.${fieldName}.link`],
              to: StorageFieldLinks[fieldName]
            }}
          />
          {prefixesShowMap.includes(fieldName) && (
            <FieldInputNumber
              name={`${fieldName}_lifetime`}
              label={intl.messages[`settings.signature.token-lifetime.title`]}
              errorMessage={intl.messages[errors?.[fieldName]] as string}
              hideArrows
            />
          )}
        </CustomFieldsWrapper>
        {prefixesShowMap.includes(fieldName) && (
          <CustomMapWrapper key={`${fieldName}_map_table`}>
            <MappingFields fieldName={fieldName} />
          </CustomMapWrapper>
        )}
      </CheckListCardContent>
    </CustomStorageCardWrapper>
  );
};

export default CustomStorageCard;
